import {Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Tooltip} from "@mui/material";
import {useState, useCallback, useRef} from "react";
import {useSocketCommands} from '../../hooks/useSocketCommands';
import {useTaskFlow} from "../../context/TaskFlowContext";
import {AnalysisTaskSubProcess, CommandType, TaskStatusType} from "../../types/taskFlow.types";
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next'

export default function Chat() {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState<Array<{text: string, isUser: boolean}>>([]);
  const { getConversionId, analysis, executeTask } = useSocketCommands();

    const { t } = useTranslation()

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const handleTooltipOpen = () => {
        setTooltipOpen(true);
    };

    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };

  const { conversionId, handleSetTaskProcess, handleSetPrompt, taskProcess, taskListProcess } = useTaskFlow()

  const checkCurrentTaskComplete = useCallback(() => {
      let completed = true;

      const analysisTask = [...(taskProcess || [])].reverse()?.find(task => task.triggerCmd === CommandType.ANALYSIS);
      const parserTaskCard =  taskProcess?.find(task => task.triggerCmd === CommandType.PARSER_TASK_CARD);
      const taskListStatus = taskListProcess?.find((item) => item.conversationId === conversionId)?.status;

      const conversionItem = analysisTask?.status ? JSON.parse(analysisTask.status) : null;
      const stepStatus = conversionItem?.stepStatus;
      const selfStatus = conversionItem?.selfStatus;
      const task = analysisTask?.response && 'data' in analysisTask.response ? analysisTask.response.data as AnalysisTaskSubProcess[] : null;

      task?.forEach(t => {
          const subTaskStatus = stepStatus[t.toolName];
          if (subTaskStatus !== TaskStatusType.COMPLETED) completed = false;
      });

      if(parserTaskCard?.status === TaskStatusType.EXECUTING) completed = false;

      if (selfStatus === TaskStatusType.CANCELED) completed = true;

      if (selfStatus === TaskStatusType.CANCELED || taskListStatus === 'inactive') completed = true;

      return completed;
  }, [taskProcess, taskListProcess]);

  const handleSend = () => {
      if (!checkCurrentTaskComplete()) {
          handleTooltipOpen()
          setTimeout(()=>{
              handleTooltipClose()
          }, 3000)
      }

    if (message.trim() && checkCurrentTaskComplete()) {
        handleSetPrompt(message)
        setMessages([...messages, { text: message, isUser: true }]);
        setMessage("");
      //  handleSetTaskProcess({content: message, triggerCmd: CommandType.SEND_PROMPT, status: TaskStatusType.EXECUTING, response: {prompt: message}})
/*       if (conversionId) {
           analysis(conversionId, message)
       }else {
           getConversionId(message);
       }*/
        getConversionId(message);
    }
  };

  const inputRef = useRef<HTMLDivElement>(null);

  const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
      const textareaElement = inputRef.current?.querySelector('textarea');
      textareaElement?.blur();
    }
  }, [handleSend]);

  return (
    <Box sx={{
      position: "absolute",
      bottom: 8,
      right: 8,
      left: 8,
      backgroundColor: checkCurrentTaskComplete() ? 'transparent' : '#999999',
      borderRadius: '12px'
    }}>
        <FormControl style={{margin: 0, width: '100%'}} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">{t('input_instruction')}</InputLabel>
            <Tooltip
                open={tooltipOpen}
                disableHoverListener
                disableFocusListener
                onClose={handleTooltipClose}
                onOpen={handleTooltipOpen}
                title={t('task_executing')}
                placement="top-start"
                arrow
            >
            <OutlinedInput
                ref={inputRef}
                id="outlined-adornment-password"
                type='text'
                style={{borderRadius: 12}}
                multiline
                disabled={!checkCurrentTaskComplete()}
                maxRows={4}
                placeholder={t('input_message')}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                fullWidth
                size="small"
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label='hide the password'
                            edge="end"
                        >
                            <SendIcon style={{fontSize: 20, color: checkCurrentTaskComplete() ? 'var(--c-accent)' : ''}} onClick={handleSend} />
                        </IconButton>
                    </InputAdornment>
                }
                label={t('password')}
            />
            </Tooltip>
        </FormControl>
    </Box>
  );
}